export const ON_ERROR = "bananan"
export const PREP_REQUEST = 'prep_request'